// extracted by mini-css-extract-plugin
module.exports = {"root":"table-column-header-cell_root__k8T2v"};